var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRepair = function SvgRepair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.722 18.35-5.045-5.047h-.942l-2.418 2.42v.942l5.045 5.047a.947.947 0 0 0 1.342 0l2.018-2.019a.949.949 0 0 0 0-1.343Zm-2.694 1.353-4.035-4.038.675-.676 4.036 4.038-.676.676Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.6 10.751 1.342-1.342 2.018 2.018a2.857 2.857 0 0 0 0-4.037l-3.37-3.371-1.341 1.343V2.676L15.583 2l-3.37 3.371.676.676h2.694L14.24 7.39l1.008 1.01-2.75 2.751-3.931-3.933V5.866L5.694 2.99 3 5.685l2.884 2.886h1.342l3.93 3.933-.808.809H8.33L3.286 18.36a.949.949 0 0 0 0 1.343l2.017 2.018a.948.948 0 0 0 1.342 0l5.045-5.047v-2.018l4.902-4.905 1.008 1Zm-7.595 4.905L5.97 19.692l-.676-.676 4.035-4.038.676.677Z"
  })));
};
export default SvgRepair;